import React, { useEffect } from "react";
import gql from "graphql-tag";
import { useLazyQuery } from "@apollo/client/react";

import SubHeader from "../SubHeader";

const FETCH_CUP_KNOCKOUT_FIXTURES = gql`
  query ($seasonId: String!, $activeCup: Int!) {
    getCupKnockoutFixtures(seasonId: $seasonId, activeCup: $activeCup) {
      _id
      Round
      RoundOrder
      Fixtures {
        Leg
        Week
        Matches {
          MatchNumber
          FixtureName
          Team1 {
            TeamName
            Points
            Aggregate
          }
          Team2 {
            TeamName
            Points
            Aggregate
          }
        }
      }
    }
  }
`;

function CupKnockoutFixtures(props) {
  const { seasonId, activeCup } = props;

  const [
    loadCupKnockoutFixturesData,
    { loading, data: { getCupKnockoutFixtures: cupKnockoutFixtures } = {} },
  ] = useLazyQuery(FETCH_CUP_KNOCKOUT_FIXTURES);

  useEffect(() => {
    if (seasonId && activeCup) {
      loadCupKnockoutFixturesData({ variables: { seasonId, activeCup } });
    }
  }, [seasonId, activeCup]);

  return (
    <div>
      {loading ? (
        <div>Loading cup tables...</div>
      ) : (
        cupKnockoutFixtures &&
        cupKnockoutFixtures
          .slice()
          .sort((a, b) => b.RoundOrder - a.RoundOrder)
          .map((ckf) => {
            const isTwoLegged = ckf.Fixtures.length === 2;

            return (
              <React.Fragment key={ckf._id}>
                <SubHeader subTitle={ckf.Round} />
                <table>
                  <thead>
                    <tr>
                      <th>Leg</th>
                      <th>GW</th>
                      <th>Fixtures</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ckf.Fixtures.map((fixture) => {
                      const isSecondLeg = fixture.Leg === 2;
                      const showAggregate = isTwoLegged && isSecondLeg;

                      return (
                        <tr
                          className="cup-knockout-fixtures-row"
                          key={fixture.Leg}
                        >
                          <td>{fixture.Leg}</td>
                          <td>{fixture.Week}</td>
                          <td>
                            <table className="cup-knockout-fixtures">
                              <tbody>
                                {fixture.Matches.map((match) => {
                                  let team1Winner = false;
                                  let team2Winner = false;

                                  if (showAggregate) {
                                    team1Winner = match.Team1.Aggregate > match.Team2.Aggregate;
                                    team2Winner = match.Team2.Aggregate > match.Team1.Aggregate;
                                  } else if (!isTwoLegged) {
                                    team1Winner = match.Team1.Points > match.Team2.Points;
                                    team2Winner = match.Team2.Points > match.Team1.Points;
                                  }
                                  
                                  return (
                                    <tr key={match.MatchNumber}>
                                      <td width="35%" className={team1Winner ? "cup-winner" : ""}>
                                        {match.Team1.TeamName}
                                      </td>
                                      <td width="10%">
                                        {match.Team1.Points}
                                        {showAggregate && (
                                          <span className="aggregate-score">
                                            {" "}({match.Team1.Aggregate})
                                          </span>
                                        )}

                                      </td>
                                      <td width="10%">vs</td>
                                      <td width="10%">
                                        {match.Team2.Points}
                                        {showAggregate && (
                                          <span className="aggregate-score">
                                            {" "}({match.Team2.Aggregate})
                                          </span>
                                        )}
                                      </td>
                                      <td width="35%" className={team2Winner ? "cup-winner" : ""}>
                                        {match.Team2.TeamName}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </React.Fragment>
            );
          })
      )}
    </div>
  );
}

export default CupKnockoutFixtures;
